import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  DialogContent,
  DialogTitle,
  FormGroup,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LayerCheckbox } from './layer-checkbox';

interface BuilderViewLayerSelectionModalProps {
  setShowingModal: (value: boolean) => void;
  showingModal: boolean;
  toggleBuilderViewLayer: (value: string) => void;
  selectedLayers: string[];
}

export const BuilderViewLayerSelectionModal = ({
  toggleBuilderViewLayer,
  selectedLayers,
  showingModal,
  setShowingModal,
}: BuilderViewLayerSelectionModalProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    setShowingModal(false);
  };

  return (
    <>
      <Dialog
        data-testid="land-visualization-modal"
        className="land-visualization-modal land-visualization-more-info"
        fullScreen={fullScreen}
        open={showingModal}
        onClose={handleClose}
        aria-labelledby="land-visualization-modal-title"
        maxWidth="lg"
        sx={{
          minWidth: { xs: 'initial', sm: '100%' },
          maxWidth: { xs: 'initial', sm: '100%' },
          height: '100%',
          width: { xs: '100%', sm: '400px' },
        }}
      >
        <Box
          className="container"
          sx={{
            minWidth: { xs: '100%', sm: '400px' },
            height: { xs: '100%', sm: 'fit-content' },
            width: { xs: '100%', sm: '400px' },
          }}
        >
          <DialogContent className="content" sx={{ height: '100%' }}>
            {
              <>
                <Box className="land-visualization-more-info-close-button-container">
                  <Button
                    onClick={() => handleClose()}
                    className="exit-land-visualization-modal-button exit-land-visualization-more-info-close-button"
                  >
                    <CloseIcon />
                  </Button>
                </Box>
                <DialogTitle
                  sx={{
                    padding: '12px',
                    fontSize: '24px',
                    textAlign: 'center',
                  }}
                  id="data-modal-title"
                >
                  {'Builder View Layers'}
                </DialogTitle>

                <FormGroup
                  sx={{
                    padding: '0 32px',
                  }}
                >
                  <LayerCheckbox
                    layer={'Setbacks'}
                    selectedLayers={selectedLayers}
                    toggleBuilderViewLayer={toggleBuilderViewLayer}
                  />
                  <LayerCheckbox
                    layer={'Topography'}
                    selectedLayers={selectedLayers}
                    toggleBuilderViewLayer={toggleBuilderViewLayer}
                  />
                  <LayerCheckbox
                    layer={'Flood Zone'}
                    selectedLayers={selectedLayers}
                    toggleBuilderViewLayer={toggleBuilderViewLayer}
                  />
                  <LayerCheckbox
                    layer={'Wetlands'}
                    selectedLayers={selectedLayers}
                    toggleBuilderViewLayer={toggleBuilderViewLayer}
                  />
                  <LayerCheckbox
                    layer={'Home Placement'}
                    selectedLayers={selectedLayers}
                    toggleBuilderViewLayer={toggleBuilderViewLayer}
                  />
                </FormGroup>
              </>
            }
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};
